export const blue = "#19B5FE";
export const lightgrey = "#707070";
